// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--3hRE-","socialItem":"social-module--socialItem--1uK65"};